
import Vue from 'vue';
import { mapState } from 'vuex';
import ProductInfo from './ProductInfo';
import ReviewForm from './ReviewForm';

export default {
  i18nComponentKey: 'ReviewsEditLegacy.components.ReviewEditDialog',
  name: 'ReviewEditDialog',
  components: {
    ProductInfo,
    ReviewForm
  },
  props: {
    reviewId: { type: Number, required: true },
    password: { type: String, default: '' }
  },
  data() {
    return {
      isLoading: true,
      review: null,
      isSubmittable: true,
      formEventBus: new Vue()
    };
  },
  computed: {
    ...mapState(['api'])
  },
  created() {
    this.api
      .get(`/reviews/${this.reviewId}/edit_legacy`)
      .then(({ data }) => (this.review = data.review))
      .finally(() => (this.isLoading = false));
  }
};
